module.exports = __webpack_public_path__ + "static/media/img1.d9e83b89.jpg";